import Act from "../actions";

const initState = {
  fileData: {}, // 讀取xlsx檔案後得到的資料，JSON格式
};

const importReducer = (state = initState, action) => {
  switch (action.type) {
    case Act.SET_FILEDATA:
      return { ...state, fileData: action.payload };
    default:
      return state;
  }
};

export default importReducer;
